import { Delegator, MobileAppsMessages, User, XolaMobileApp } from "types";
import { useXolaMobileApps } from "@/components/MobileApps/XolaMobileAppsContext";
import { useAccount } from "@/hooks/useAccount";
import { useAccountStore } from "@/stores/accountStore";
import { isOAuthSession } from "@/stores/authStore";

export const reloadAppWithDelegator = (user: User, delegator: Delegator, hasSavedLogin = false) => {
    const rememberMe = hasSavedLogin ? 1 : 0;
    const credential = isOAuthSession() ? "" : `&apiKey=${user.apiKey}`;
    const hashParams = `seller=${delegator.id}${credential}&rememberMe=${rememberMe}`;

    if (window.location.pathname === "/") {
        window.location.hash = hashParams;
        window.location.reload();
        return;
    }

    window.location.href = `/#${hashParams}`;
};

export const useSwitchDelegator = () => {
    const { data } = useAccount();
    const hasSavedLogin = useAccountStore((state) => state.hasSavedLogin());
    const { sendMessage, xolaMobileApp } = useXolaMobileApps();

    const switchDelegator = (delegator: Delegator) => {
        if (xolaMobileApp === XolaMobileApp.XolaTablet) {
            sendMessage({
                type: MobileAppsMessages.SWITCH_ACCOUNT,
                payload: { delegatorId: delegator.id },
            });
        }

        if (data?.user) {
            reloadAppWithDelegator(data.user, delegator, hasSavedLogin);
        }
    };

    return { switchDelegator };
};
